import { invokeApi } from "src/bi_lib/invokeApi";


export const login = async (data) => {
    const requestObj = {
        path: `/admin_users/`,
        method: "POST",
        headers: {
            // 'x-sh-auth': 1234
        },
        postData: data,
    };
    return invokeApi(requestObj);
};

export const twoFactorVerification = async (data) => {
    const requestObj = {
        path: `/admin_users/verify_login_admin_user`,
        method: "POST",
        postData: data,
    };
    return invokeApi(requestObj);
};
export const resendTwoFactorVerification = async (data) => {
    const requestObj = {
        path: `/admin_users/resend_verification_code`,
        method: "POST",
        postData: data,
    };
    return invokeApi(requestObj);
};

export const toggleTwoFactorApi = async (data) => {
    const requestObj = {
        path: `/admin_users/toggle_2fa`,
        method: "POST",
        postData: data,
        headers: {
            "x-sh-auth": localStorage.getItem("token"),
        },
    };
    return invokeApi(requestObj);
};


export const changeAdminPasswordApi = async (data) => {
    const requestObj = {
        path: `/admin_users/admin_change_password`,
        method: "POST",
        headers: {
            "x-sh-auth": localStorage.getItem("token"),
        },
        postData: data,
    };
    return invokeApi(requestObj);
};

export const logout = async () => {
    const requestObj = {
        path: `/admin_users/logout`,
        method: "POST",
        headers: {
            "x-sh-auth": localStorage.getItem("token"),
        },
    };
    return invokeApi(requestObj);
};

export const updateAdminProfile = async (data) => {
    const requestObj = {
        path: `/admin_users/update_admin_user`,
        method: "PUT",
        headers: {
            'x-sh-auth': localStorage.getItem('token')
        },
        postData: data,
    };
    return invokeApi(requestObj);
};
